import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { DynamicContentBookmark } from "./dynamics";

export type BookmarkProps = {
  $variant?: "default" | "magazines-style";
};

export const StyledContentBookmark = styled(DynamicContentBookmark)<BookmarkProps>`
  inline-size: 18px;
  block-size: 18px;
  padding: 0;

  path:last-of-type {
    fill: #001246;
  }

  ${props =>
    props.$variant === "magazines-style" &&
    css`
      path[opacity] {
        fill: #d7d7d7;
        opacity: 1;
      }
    `}
`;
